// extracted by mini-css-extract-plugin
module.exports = {"animationWrapper":"solarpanel_400w_animationWrapper__5_2ZP"};